import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IRefWithAttendant } from './interface/IRefWithAttendant';

@Entity('ref_with_attendant')
export class RefWithAttendant extends BaseEntity implements IRefWithAttendant{
  apiMapping = {
      id: 'id',
      name: 'name',
  };

  @PrimaryGeneratedColumn()
  id: number;

  @Column()
  name: string;

  @Column({ nullable: true })
  isDeleted: boolean;
}
